<h1 id="page-title">Create New Claim</h1>

<app-wizard
        (closeClick)="closeWizard()"
        (saveClick)="saveClaim()"
        (sendClick)="sendClaim()"
        (discardClick)="closeWizard()"
        [disableContinue]=""
        [disableSave]="!canSave"
        [disableSend]="!canSend"
        [formSubmitted]="false"
        [linear]="true">

    <cdk-step [completed]="false" [label]="'1. Claim Information'" [optional]="false">
        <app-step-claim-information [stepIndex]="0"></app-step-claim-information>
    </cdk-step>

    <cdk-step [completed]="false" [label]="'2. Position Detail'" [optional]="false">
        <app-step-position-detail [stepIndex]="1"></app-step-position-detail>
    </cdk-step>

    <cdk-step [completed]="true" [label]="'3. Confirm and Send'" [optional]="true">
        <app-step-confirm-send [stepIndex]="2"></app-step-confirm-send>
    </cdk-step>
</app-wizard>
